// @flow
import React from 'react';
import type { ChildrenArray, Element } from 'react';
import {
  types as t,
  usePropsValidation,
} from '../validation/runtime-checks/index.js';
import color from '../color.js';
import bullet from './bullet.svg';
import { Heading, SubHeading } from '../Heading.js';
import Latex from '../Latex.js';
import { productColor } from '../designSystem.js';
import { LatexTextAtom } from '../LatexTextAtom.js';

export function TSOLearningTargetsList(props: {|
  children: $ReadOnlyArray<Element<typeof TSOLearningTarget>>,
|}) {
  const { failedValidation } = usePropsValidation(
    props,
    TSOLearningTargetsList,
  );

  if (failedValidation) return null;

  return (
    <div style={{ color: productColor.shuttleGrey }}>
      <Heading>
        Learning objective{props.children.length > 1 ? 's' : ''}
      </Heading>
      <div
        style={{
          fontFamily: 'Proxima Nova',
        }}
      >
        <SubHeading>Students will be able to:</SubHeading>
        <ul style={{ paddingLeft: 16 }}>{props.children}</ul>
      </div>
    </div>
  );
}

TSOLearningTargetsList.spec = {
  children: t.minimumCount(1, t.elementType(TSOLearningTarget)),
};

export function TSOLearningTarget(props: {|
  children: ChildrenArray<
    string | Element<typeof Latex> | Element<typeof LatexTextAtom>,
  >,
|}) {
  const { failedValidation } = usePropsValidation(props, TSOLearningTarget);

  if (failedValidation) return null;

  return (
    <li
      style={{
        color: color.shuttleGray,
        listStyleImage: `url(${bullet})`,
        marginBottom: 10,
        listStylePosition: 'outside',
      }}
    >
      {props.children}
    </li>
  );
}

TSOLearningTarget.spec = {
  children: t.childrenArray(
    t.unionOfTypes(
      t.string,
      t.elementType(Latex),
      t.elementType(LatexTextAtom),
    ),
  ),
};
